module.exports = __webpack_public_path__ + "static/media/lunalogistik-office-london-uk.8fa65bb0.png";